export default __webpack_public_path__ + "static/media/loginIcon.5fe55f45.svg";